import { Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Select2OptionData } from 'ng-select2';

import { CitiesService, DateService, SpinnerService } from '../../../app/common';
import { AppConfig } from '../../app.config';
import { AuthService } from '../../common/auth/auth.service';
import { GetCitiesService } from '../../common/get-cities.service';
import { Config } from '../shell';
declare var jQuery: any;

@Component({
  selector: '[navbar]',
  templateUrl: './navbar.template.html'
})
export class NavbarComponent implements OnInit {
  @Output() toggleSidebarEvent: EventEmitter<string> = new EventEmitter();
  @Output() toggleChatEvent: EventEmitter<string> = new EventEmitter();
  $el: any;
  config: Config;
  router: Router;
  authService: AuthService;
  cities: Array<Select2OptionData>;
  city: string;
  userFirstName: string;
  userLastName: string;
  public currentCity: string;

  constructor(el: ElementRef,
    config: AppConfig,
    router: Router,
    authService: AuthService,
    private citiesService: CitiesService,
    private spinnerService: SpinnerService,
    private dateService: DateService,
    private getCitiesService: GetCitiesService
  ) {
    this.$el = jQuery(el.nativeElement);
    this.config = config.getConfig();
    this.router = router;
    this.authService = authService;
  }

  toggleSidebar(state: string): void {
    this.toggleSidebarEvent.emit(state);
  }

  ngOnInit(): void {
    const userInfo = this.authService.getUserInfo();
    if (userInfo) {
      this.userFirstName = userInfo['first_name'];
      this.userLastName = userInfo['last_name'];
    }
    if (this.getCitiesService.citiesList().length) {
      this.cities = this.getCitiesService.citiesList();
      this.city = localStorage.getItem('sg_city_id') || this.cities[0].id;
      this.setOffset();
    } else {
      this.getCitiesService.getCities()
        .subscribe((cities: any) => {
          this.cities = cities;
          this.getCitiesService.citiesList(cities);
          this.city = localStorage.getItem('sg_city_id') || cities[0].id;
          this.setOffset();
        });
    }
  }

  onLogoutClick() {
    this.spinnerService.change(true);
    this.authService.clearSession()
      .subscribe(() => {
        this.spinnerService.change(false);
        this.authService.logout();
      }, (err) => {
        this.spinnerService.change(false);
        this.authService.logout();
      });
  }

  onCityChange(cityId: string) {
    this.changeCity(cityId);
  }

  setOffset() {
    const currentCity = this.cities.find((city) => this.city === String(city.id));
    this.dateService.setCity(currentCity);
  }

  onRefresh() {
    window.location.reload();
  }

  changeCity(cityId: string) {
    const city = this.cities.find(city => cityId === String(city.id));
    if (city) {
      this.citiesService.changeCity(city.id, city['offset'], city['online_locations_count']);
    } else {
      this.citiesService.changeCity(cityId);
    }
  }
}
